/* eslint-disable no-console */
import { IS_DEV } from '../config/env'

/**
 * Prints error to console in DEV only
 * @param message
 * @param perams.persistInProd flag that enables message to persist in production build
 * @returns void
 */
export const printError = (
    message: string | Error | string[] | Error[],
    params?: { persistInProd: boolean; stacktrace?: string }
): void => {
    const stackMsg = params?.stacktrace ? `Stack:\r\n ${params?.stacktrace}` : ''
    if (!params?.persistInProd && !IS_DEV) return
    if (!Array.isArray(message)) console.error(message, stackMsg)
    else {
        console.group()
        const messageArr = message as string[]
        messageArr.forEach((messageItem) => console.error(messageItem))
        console.error(stackMsg)
        console.groupEnd()
    }
}

/**
 * Prints warning to console in DEV only
 * @param message
 * @param perams.persistInProd flag that enables message to persist in production build
 * @returns void
 */
export const printWarning = (message: string, params?: { persistInProd: boolean }): void => {
    if (!params?.persistInProd && !IS_DEV) return
    console.warn(message)
}

/**
 * Prints log to console in DEV only
 * @param message
 * @param perams.persistInProd flag that enables message to persist in production build
 * @returns void
 */
export const printMessage = (message: string, params?: { persistInProd: boolean }): void => {
    if (!params?.persistInProd && !IS_DEV) return
    console.log(message)
}
